import type { AutomationFlag, FlagSeverity } from '@/types/automationFlags';

const SEVERITY_RANK: Record<FlagSeverity, number> = {
  info: 0,
  warning: 1,
  error: 2,
};

export function parseAutomationFlags(raw: unknown): AutomationFlag[] {
  if (!Array.isArray(raw)) return [];
  return raw.filter((item): item is AutomationFlag => {
    if (!item || typeof item !== 'object') return false;
    const flag = item as AutomationFlag;
    return typeof flag.code === 'string' && typeof flag.severity === 'string' && typeof flag.message === 'string';
  });
}

export function highestFlagSeverity(flags: AutomationFlag[]): FlagSeverity | null {
  let highest: FlagSeverity | null = null;
  for (const flag of flags) {
    if (highest == null || SEVERITY_RANK[flag.severity] > SEVERITY_RANK[highest]) {
      highest = flag.severity;
    }
  }
  return highest;
}

export function hasErrorFlags(flags: AutomationFlag[]): boolean {
  return flags.some((flag) => flag.severity === 'error');
}

export function flagBadgeLabel(severity: FlagSeverity): string {
  return severity === 'error' ? 'Conflict' : 'Overlap';
}

export function formatFlagEntities(flag: AutomationFlag): string {
  const names = flag.entities.map((entity) => entity.name || entity.id).filter(Boolean);
  if (names.length === 0) {
    return flag.entity_count > 0 ? `${flag.entity_count} campaigns` : '';
  }
  const extra = flag.entity_count > names.length ? flag.entity_count - names.length : 0;
  if (extra > 0) return `${names.join(', ')} +${extra}`;
  return names.join(', ');
}
